import React, { useState } from 'react';

export default function TrainingPartner() {
    const [searchTerm, setSearchTerm] = useState('');

    const mcpData = [
        {
            id: 1,
            name: "Neeraj College of Mgt. & Tech.",
            location: "Devi Lal Colony, Bhramchari Road, Mohindergarh – 123029",
            contactPerson: "Udham Siwatch",
            contactNumbers: "9416658007, 8930648008"
        },
        {
            id: 2,
            name: "International Institute of Mass Media",
            location: "B-50, South Extension -1, New Delhi – 110049",
            contactPerson: "Subhash Bhagat",
            contactNumbers: "9350042595"
        },
        {
            id: 3,
            name: "JKCS Edu India Foundation",
            location: "Under Overbridge, Near Sidharth Guest House, MC Colony, New Bus Stand, Sirsa – 125055",
            contactPerson: "Joginder Kumar",
            contactNumbers: "9306977442"
        },
        {
            id: 4,
            name: "Deep Computer Centre",
            location: "Near Kakkar Furniture, Outside Barsi Gate, Hansi – 125033",
            contactPerson: "Sandeep",
            contactNumbers: "9992772070"
        },
        {
            id: 5,
            name: "M/s Preamble IAS",
            location: "SCO:19, 2nd Floor, Above Bank of Baroda, PKT-B, Sec-14, Gate No. 02, Hisar",
            contactPerson: "Ved Parkash",
            contactNumbers: "9999290899"
        },
        {
            id: 6,
            name: "i-Care Technology",
            location: "Gali No. 1, Rishi Nagar, Hisar – 125001",
            contactPerson: "Bharat Bhushan",
            contactNumbers: "9996994495"
        },
        {
            id: 7,
            name: "Sanlok Institute of Management & IT",
            location: "168/8, Model Town, Sector 11, Gurugram – 122001",
            contactPerson: "Lokesh Mehta",
            contactNumbers: "9891936274"
        },
        {
            id: 8,
            name: "JSB Technologies",
            location: "HARTRON Building, Opposite Bus Stand, Near Manglam Lab, Hansi",
            contactPerson: "Amit Kumar Berwal",
            contactNumbers: "9354720005"
        },
        {
            id: 9,
            name: "Alpha Technology",
            location: "Vishavkarma Mandir Road, Near Bus Stand, Hisar – 125001",
            contactPerson: "Rajeev Monga",
            contactNumbers: "9812042279, 9215542279"
        },
        {
            id: 10,
            name: "HiTech Computers",
            location: "Opp. New Bus Stand, VPO. Tosham, Distt. Bhiwani",
            contactPerson: "Mukesh Kumar Rakheja",
            contactNumbers: "8950493597"
        },
        {
            id: 11,
            name: "Mazars Advisory LLP",
            location: "Plot No. 51-52, Phase IV, Udyog Vihar, Sector 18, Gurugram – 122016",
            contactPerson: "Dr. Sanjay Bhardwaj",
            contactNumbers: "9871922449"
        },
        {
            id: 12,
            name: "G R Institute of Management & Tech.",
            location: "Devi Lal Colony, Near Kanwar Singh MLA Residence, Mahendergarh – 123029",
            contactPerson: "Gyani Ram",
            contactNumbers: "7027800922, 7027100922"
        },
        {
            id: 13,
            name: "R.D. Institute of Management & Tech.",
            location: "Ward No. 2, Gandhi Nagar, Charkhi Dadri",
            contactPerson: "Jatin Sheoran",
            contactNumbers: "9812255088"
        },
        {
            id: 14,
            name: "Shri Shyam Education & Welfare Society",
            location: "789, Shiv Colony, Mandi Adampur, Distt. Hisar – 125052",
            contactPerson: "Shyam Sunder",
            contactNumbers: "9896999300"
        },
        {
            id: 15,
            name: "Shaheed Bhagat Singh College",
            location: "NH-3, Central Green Area, Opposite Block 3B, Faridabad – 121001",
            contactPerson: "Yadvinder Singh",
            contactNumbers: "9810294702"
        },
        {
            id: 16,
            name: "Aakash Enterprises",
            location: "H. No. 1969 B, Sector 16-17, Hisar – 125001",
            contactPerson: "Rajesh Kumar",
            contactNumbers: "8683955693"
        },
        {
            id: 17,
            name: "ODM Computer & Management Education",
            location: "DPG Degree College Campus, Sector 34, Gurgaon – 122004",
            contactPerson: "Bhoop Singh",
            contactNumbers: "9899677890"
        },
        {
            id: 18,
            name: "British American Institute",
            location: "Khanna Complex, Gate No. 4, Cheeka - Patiala Road, Kaithal – 136027",
            contactPerson: "Aman Kumar Khanna",
            contactNumbers: "9729998889"
        }
    ];

    const filteredData = mcpData.filter(mcp =>
        mcp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        mcp.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
        mcp.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
        mcp.contactNumbers.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
            <div className="max-w-7xl mx-auto">
                <div className="bg-white rounded-lg shadow-xl p-6 mb-6">
                    <h2 className="text-3xl font-bold text-gray-800 mb-2">
                        Details of Training Partners
                    </h2>
                    {/* <p className="text-gray-600 mb-6">
                        Centre for Distance and Online Education, Guru Jambheshwar University of Science & Technology
                    </p> */}

                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search by Contact Number"
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-indigo-600 text-white">
                                <tr>
                                    <th >Sr. No.</th>
                                    <th >Name of Partner</th>
                                    <th >Address</th>
                                    <th>Nodal Officer</th>
                                    <th >Contact Number</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {filteredData.map((mcp, index) => (
                                    <tr
                                        key={mcp.id}
                                        className={index % 2 === 0 ? 'bg-white hover:bg-gray-50' : 'bg-gray-50 hover:bg-gray-100'}
                                    >
                                        <td >
                                            {mcp.id}
                                        </td>
                                        <td >
                                            {mcp.name}
                                        </td>
                                        <td >
                                            {mcp.location}
                                        </td>
                                        <td >
                                            {mcp.contactPerson}
                                        </td>
                                        <td >
                                            {mcp.contactNumbers}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {filteredData.length === 0 && (
                        <div className="p-12 text-center">
                            <p className="text-gray-500 text-lg">No MCPs found matching your search.</p>
                        </div>
                    )}
                </div>

                <div className="mt-6 bg-white rounded-lg shadow-lg p-4 text-center">
                    <p className="text-sm text-gray-600">
                        Showing <span className="font-semibold text-indigo-600">{filteredData.length}</span> of <span className="font-semibold text-indigo-600">{mcpData.length}</span> MCPs
                    </p>
                </div>
            </div>
        </div>
    );
}